<template>
  <TableTab :product="product" :subscription="subscription" />
</template>

<script lang="ts" setup>
import TableTab from '~/components/price-assessments/TableTab.vue'
import type { TProduct } from '~/src/types/product.ts'

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ isTab: true })

/*-------------------------------------
  Props & Refs
-------------------------------------*/
defineProps<{
  product: TProduct
  subscription: string
}>()
</script>
